"use client";

import { useState } from "react";
import BasicModal from "../../utils/modals/BasicModal";
import Button from "../Button";
import "./index.scss";

const ButtonModal = ({
  buttonText,
  children,
  className,
}: {
  buttonText: string;
  children: any;
  className?: string;
}) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <div className="component button-modal">
      <Button onClick={() => setIsModalOpened(true)} className={className}>
        {buttonText}
      </Button>

      <div
        className={`modal-container ${isModalOpened ? "" : "visually-hidden"}`}
        aria-hidden={!isModalOpened}
      >
        <BasicModal onClose={() => setIsModalOpened(false)}>
          {children}
        </BasicModal>
      </div>
    </div>
  );
};

export default ButtonModal;
